import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const MaskType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Mask Type</InputLabel>
      <Select
        label="Mask Type"
        value={moduleValues?.['Mask Type'] ?? ''}
        fullWidth
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Mask Type']: e.target.value,
          }))
        }
      >
        <MenuItem value='Non Re-Breather'>Non Re-Breather</MenuItem>
        <MenuItem value='Face Mask'>Face Mask</MenuItem>
        <MenuItem value='Nebuliser'>Nebuliser</MenuItem>
        <MenuItem value='Nasal Cannula'>Nasal Cannula</MenuItem>
        <MenuItem value='CPAP'>CPAP</MenuItem>
        <MenuItem value='Other'>Other</MenuItem>
        </Select>
    </FormControl>
  </Grid>
)
export default MaskType
